<ng-container *transloco="let t">
  <div class="paywall-modal" role="dialog" aria-modal="true" aria-label="Premium upgrade" (keydown)="onKeydown($event)">
    <div
      class="paywall-backdrop"
      [attr.role]="dismissible ? 'button' : null"
      [attr.tabindex]="dismissible ? 0 : null"
      [attr.aria-label]="dismissible ? t('Close paywall') : null"
      (click)="notNow()"
      (keydown.enter)="notNow()"
      (keydown.space)="notNow()"></div>
    @if (!upgradeUnavailable) {
      <div
        class="paywall-sheet"
        tabindex="0"
        (click)="$event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()">
        @if (paywallRendered && dismissible) {
          <button type="button" class="paywall-close-button" aria-label="Close paywall" (click)="notNow()">
            <span aria-hidden="true">&times;</span>
          </button>
        }
        @if (paywallRendered && !dismissible) {
          <div class="paywall-overflow-wrapper">
            <button
              type="button"
              class="paywall-overflow-button"
              aria-label="More options"
              aria-haspopup="menu"
              [attr.aria-expanded]="overflowMenuOpen"
              (click)="toggleOverflowMenu()">
              <svg-icon class="paywall-overflow-icon" src="/assets/icons/ellipsis.svg"></svg-icon>
            </button>
            @if (overflowMenuOpen) {
              <div class="paywall-overflow-menu" role="menu">
                <button
                  type="button"
                  role="menuitem"
                  class="paywall-overflow-item paywall-overflow-help"
                  (click)="getHelp()">
                  {{ t('Get Help') }}
                </button>
                <button
                  type="button"
                  role="menuitem"
                  class="paywall-overflow-item paywall-overflow-signout"
                  (click)="signOut()">
                  {{ t('Sign Out') }}
                </button>
              </div>
            }
          </div>
        }
        @if (error) {
          <div class="error" role="alert">{{ error }}</div>
        }
        <div class="paywall-container" [class.paywall-visible]="paywallStarted" #paywallContainer></div>
      </div>
    } @else {
      <div
        class="paywall-modal-card-host"
        tabindex="0"
        (click)="$event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()">
        <div class="upgrade-unavailable-content">
          <h2 id="upgrade-unavailable-title">{{ t('Upgrade unavailable') }}</h2>
          <p>{{ t("We couldn't load upgrade options right now. Please try again later.") }}</p>
          @if (dismissible) {
            <button
              type="button"
              class="button button-pill button-reverse button-modal"
              (click)="acknowledgeUpgradeUnavailable()">
              {{ t('OK') }}
            </button>
          } @else {
            <div class="upgrade-unavailable-actions">
              <button type="button" class="button button-pill button-reverse button-modal" (click)="getHelp()">
                {{ t('Get Help') }}
              </button>
              <button
                type="button"
                class="button button-pill button-modal upgrade-unavailable-signout"
                (click)="signOut()">
                {{ t('Sign Out') }}
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-container>
